import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UIView } from '@uirouter/react';
import { Button } from 'antd';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Table } from '@/components/table';
import { getGenericFilters, toQueryFormat } from '@/components/table/utils';
import { PERMISSION_CREATE, PERMISSION_OBJ_COOPERATIVE } from '@/constants/permissions';
import { withPermissions } from '@/hocs/permission';
import { cooperativeStore } from '@/stores';

import { columns } from './setup';

const store = cooperativeStore;

const CreateButton = withPermissions([[PERMISSION_OBJ_COOPERATIVE, PERMISSION_CREATE]])(({ onClick }: any) => (
  <Button onClick={onClick} type="primary" icon={<FontAwesomeIcon icon={faPlus} />}>
    &nbsp;&nbsp;
    <FormattedMessage id="cooperatives.add-new" />
  </Button>
));

export const Cooperatives = observer(({ transition }: any) => {
  useEffect(() => {
    store.forceLoad();
  }, []);

  const items = store.items;
  const genericFilters = useMemo(() => getGenericFilters(columns), []);

  const onAdd = () => {
    transition.router.stateService.go('base-layout.cooperatives.create');
  };

  const onRow = (record: cyrian.api.cooperatives.Cooperative) => ({
    onClick: () =>
      transition.router.stateService.go('base-layout.cooperatives.view', {
        cooperativeId: record.id,
      }),
    className: 'table-row-cursor',
  });

  const onChangeTable = (...args: any[]) => {
    const params = toQueryFormat.apply(null, [genericFilters, ...args]);
    store.forceLoad(params);
  };

  return (
    <>
      <CreateButton onClick={onAdd} />
      <Table
        rowKey="id"
        columns={columns}
        dataSource={[...items]}
        store={store}
        onRow={onRow}
        onChange={onChangeTable}
      />
      <UIView />
    </>
  );
});
